import TrashIcon from "../../Icons/TrashIcon";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../../main";
import { toast } from "react-toastify";
import { DeleteReview } from "../../../api/Reviews/DeleteReview";
const ReviewRow = ({
    review,
    rating,
    reviewId,
    name
}: {
    review: string;
    rating: number;
    reviewId:string;
    name:string
}) => {
    const { mutate: deleteReview } = useMutation({
        mutationFn: DeleteReview,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["reviews"] });
            toast.success("FAQ deleted successfully");
        },
    });


    return (
        <tr>
                        <td className=" px-2 first:pl-5 last:pr-5 whitespace-nowrap py-3 max-w-[10%]">
                <div className="inline-flex rounded-full text-center py-0.5 text-sm font-semibold ">
                    {name}
                </div>
            </td>
            <td  className=" px-2 first:pl-5 last:pr-5  py-3  max-w-[70%]">
                <div className="inline-fl rounded-full text-left py-0.5 text-sm font-semibold flex items-center gap-4">
                    {review}
                </div>
            </td>
            <td className=" px-2 first:pl-5 last:pr-5 whitespace-nowrap py-3 max-w-[10%]">
                <div className="inline-flex rounded-full text-center py-0.5 text-sm font-semibold ">
                    {rating}
                </div>
            </td>
            <td className="px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap max-w-[10%]">
                <div className="flex rounded-xl justify-center items-center bg-[#FAFBFD] border-[#D5D5D5] border py-3 text-sm font-semibold min-w-[50px] max-w-[50px] ml-auto text-[#EF3826]">
                    <button onClick={() => deleteReview(reviewId)}>          
                    <TrashIcon />
                    </button>
                </div>
            </td>
        </tr>
    );
};

export default ReviewRow;
